module.exports = __webpack_public_path__ + "assets/img/course_landing_top_bg.svg";